import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/error-pages/404-page.scss';
import '../../css/pages/error-pages/title-error.scss';
import '../../css/pages/error-pages/description-error.scss';
import '../../css/pages/error-pages/error-code.scss';
import '../../css/pages/error-pages/error-span.scss';

function init404Page(root: ParentNode = document): void {
  const goBack = (): void => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.assign('/');
  };

  root.querySelectorAll<HTMLElement>('[data-404-back]').forEach((element) => {
    element.addEventListener('click', goBack);
  });
}

registerPageInit('404-page', (root) => {
  init404Page(root ?? document);
});
